export const base_path = "/";
export const image_path ='/';
export const json_path ='/src/core/json/';
